export const DRAWIO_EDITOR_ROUTE = '/files/drawio-editor';

export function buildDrawioEditorSearch(mountId: string, relativePath: string): string {
  const params = new URLSearchParams();
  params.set('mountId', mountId);
  params.set('path', relativePath);
  return params.toString();
}

export function drawioEditorHref(mountId: string, relativePath: string): string {
  return `${DRAWIO_EDITOR_ROUTE}?${buildDrawioEditorSearch(mountId, relativePath)}`;
}
